module.exports = __webpack_public_path__ + "img/battikhi_ortho_logo.d274a0c1.png";